import React from "react";
import List from "features/Cart/components/List";

const CartList = () => {
  return <List />;
};

export default CartList;
